import {
  GrReactjs,
  BsGithub,
  GrHtml5,
  TbBrandCss3,
  SiRedux,
  SiTypescript,
  SiJest,
  DiMaterializecss,
  SiNetlify,
  SiJavascript,
  SiReactrouter,
  AiFillApi,
  TbBrandNextjs,
  SiStrapi,
  TbBrandReactNative,
  SiTailwindcss,
  SiAndroidstudio,
  SiXcode,
  SiJira,
  FaAws,
  TbBrandFramerMotion,
  FaNodeJs,
  SiExpress,
  SiSocketdotio,
  SiMongodb,
} from "../utils/icons";

export const technologiesList = [
  {
    tech: "ReactJs",
    techLogo: <GrReactjs />,
  },
  {
    tech: "ReactNative",
    techLogo: <TbBrandReactNative />,
  },
  {
    tech: "NextJs",
    techLogo: <TbBrandNextjs />,
  },
  {
    tech: "Redux Toolkit",
    techLogo: <SiRedux />,
  },
  {
    tech: "React Router",
    techLogo: <SiReactrouter />,
  },
  {
    tech: "Context API",
    techLogo: <AiFillApi />,
  },
  {
    tech: "AWS",
    techLogo: <FaAws />,
  },
  {
    tech: "Typescript",
    techLogo: <SiTypescript />,
  },
  {
    tech: "Framer Motion",
    techLogo: <TbBrandFramerMotion />,
  },
  {
    tech: "NodeJs",
    techLogo: <FaNodeJs />,
  },
  {
    tech: "ExpressJs",
    techLogo: <SiExpress />,
  },
  {
    tech: "MongoDB",
    techLogo: <SiMongodb />,
  },
  {
    tech: "Socket.io",
    techLogo: <SiSocketdotio />,
  },
  {
    tech: "MUIv5",
    techLogo: <DiMaterializecss />,
  },
  {
    tech: "AndroidStudio",
    techLogo: <SiAndroidstudio />,
  },
  {
    tech: "XCode",
    techLogo: <SiXcode />,
  },
];

export const toolsList = [
  {
    tech: "Bigin",
    techLogo: "",
  },
  {
    tech: "Strapi",
    techLogo: <SiStrapi />,
  },
  {
    tech: "Jira",
    techLogo: <SiJira />,
  },
  {
    tech: "Github",
    techLogo: <BsGithub />,
  },
  {
    tech: "Jest",
    techLogo: <SiJest />,
  },
  {
    tech: "Web Hosting",
    techLogo: <SiNetlify />,
  },
  {
    tech: "Tailwind CSS",
    techLogo: <SiTailwindcss />,
  },
  {
    tech: "HTML5",
    techLogo: <GrHtml5 />,
  },
  {
    tech: "CSS3",
    techLogo: <TbBrandCss3 />,
  },
  {
    tech: "Javascript",
    techLogo: <SiJavascript />,
  },
];
